import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { umsUrl } from '../../../../Containers/Config/index.js';
import { GET_CLIENT_ROLES, GET_CLIENT_ROLES_SUCCESS, GET_CLIENT_ROLES_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getClientRole({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v1/organization-roles`,
      method: 'GET',
      headers: {
        'Project-Code': `ADMIN_ACCESS`,
        Authorization: Constant?.CLIENT_TOKEN,
      },
      data: payload?.data,
      params: {
        tag: 'ADIB',
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CLIENT_ROLES_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: GET_CLIENT_ROLES_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CLIENT_ROLES_ERROR, payload: error });
  }
}

export function* watchgetClientRole() {
  yield takeEvery(GET_CLIENT_ROLES, getClientRole);
}

function* getClientRoleSaga() {
  yield all([fork(watchgetClientRole)]);
}

export default getClientRoleSaga;
